<template>
  <v-card 
    class="paciente-card-compact"
    :class="{
      'status-available-card': paciente.status === 1,
      'status-pending-card': paciente.status === 2,
      'priority-patient': hasPriority,
      'waiting-patient': isEspera,
      'elevation-2': !flat,
      'flat': flat,
      'paciente-card-selected': isSelected
    }"
    variant="outlined"
    @click="pacienteSelecionado"
  >
    <v-card-text class="pa-2">
      <div class="compact-card-content">
        <!-- Avatar -->
        <div
          class="compact-avatar"
          :class="avatarGradient"
        >
          <span class="avatar-number">
            {{ listIndex }}
          </span>
          <div
            v-if="isSelected"
            class="selection-badge"
          >
            <span class="material-icons selection-icon">check_circle</span>
          </div>
          <div
            v-if="isEspera"
            class="waiting-dot"
          />
        </div>

        <!-- Conteúdo Principal -->
        <div class="compact-info">
          <!-- Cabeçalho -->
          <div class="compact-header">
            <div class="name-line">
              <h4 class="compact-name">
                {{ paciente.nomePaciente }}
              </h4>
              <span
                v-if="hasPriority"
                class="priority-icon"
                title="Paciente prioritário"
              >
                <span class="material-icons">accessible</span>
              </span>
              <span
                v-if="idadeAtual"
                class="patient-age"
              >
                <span class="patient-age-label">Idade:</span>
                <span>{{ idadeAtual }}</span>
              </span>
            </div>

            <div class="compact-badges">
              <v-chip 
                v-if="hasPriority"
                size="x-small"
                class="priority-mini"
                color="#FF6B6B"
                rounded="0"
              >
                <span
                  class="material-icons"
                  style="font-size: 14px"
                >emergency</span>
              </v-chip>

              <v-chip 
                v-if="isEspera"
                size="x-small"
                class="waiting-mini"
                color="#FFD93D"
                rounded="0"
              >
                <span
                  class="material-icons"
                  style="font-size: 14px"
                >schedule</span>
              </v-chip>
            </div>
          </div>

          <ul class="patient-info-list">
            <li
              v-if="mostrarAgendamento"
              class="patient-info-item"
            >
              <span class="material-icons patient-info-icon">event</span>
              <span>{{ dataAgendadaLabel }}</span>
            </li>
            <li
              v-if="convenioTexto"
              class="patient-info-item"
            >
              <span class="material-icons patient-info-icon">verified_user</span>
              <span>Convênio: {{ convenioTexto }}</span>
            </li>
           
            <li
              v-if="horarioChegada"
              class="patient-info-item patient-info-item--arrival"
            >
              <span class="material-icons patient-info-icon">login</span>
              <span>Entrada: {{ horarioChegada }}</span>
            </li>
            <li
              v-if="tempoEsperaAtual"
              class="patient-info-item patient-info-item--wait"
              :class="{
                'patient-info-item--wait-warning': tempoEsperaMinutos >= 30 && tempoEsperaMinutos < 60,
                'patient-info-item--wait-danger': tempoEsperaMinutos >= 60
              }"
            >
              <span class="material-icons patient-info-icon">timer</span>
              <span>Espera: {{ tempoEsperaAtual }}</span>
            </li>
            <li
              v-if="isAtendido && horarioSaida"
              class="patient-info-item"
            >
              <span class="material-icons patient-info-icon">logout</span>
              <span>Saída: {{ horarioSaida }}</span>
            </li>
            <li
              v-if="tempoAtendimentoAtual"
              class="patient-info-item"
            >
              <span class="material-icons patient-info-icon">timelapse</span>
              <span>Atendimento: {{ tempoAtendimentoAtual }}</span>
            </li>
            <li
              v-if="paciente.numeroFicha"
              class="patient-info-item"
            >
              <span class="material-icons patient-info-icon">tag</span>
              <span>#{{ paciente.numeroFicha }}</span>
            </li>
          </ul>
          <!-- Linha de Exames -->
          <div class="exams-line">
            <!-- <div v-if="paciente.nomeExame" class="exam-chip">
              <span class="material-icons exam-icon" style="font-size: 12px">medical_services</span>
              <span class="exam-text">{{ truncateText(paciente.nomeExame, 20) }}</span>
            </div>

            <div v-if="paciente.nomeEspecialidade" class="exam-chip">
              <span class="material-icons exam-icon" style="font-size: 12px">local_hospital</span>
              <span class="exam-text">{{ truncateText(paciente.nomeEspecialidade, 15) }}</span>
            </div> -->

            <v-chip
           
              v-for="(exame, index) in (isSelected ? exames : exames.slice(0, 2))"
              :key="'ex-os-' + index"
              class="exam-chip exam-chip--large"
              :class="examChipStatusClass"
              size="small"
              variant="outlined"
              rounded="0"
            >
              <v-icon
                start
                size="x-small"
                class="exam-icon"
              >
                healing
              </v-icon>
              <span class="exam-text">{{ exame.nome || exame.descricao }}</span>
              <span
                v-if="exame.statusLabel"
                class="exam-status"
              >
                {{ exame.statusLabel }}
              </span>
            </v-chip>

            <!-- Indicador de mais exames -->
            <div 
              v-if="!isSelected && exames.length > 2" 
              class="more-exams"
            >
              +{{ exames.length - 2 }}
            </div>
          </div>

          <v-expand-transition>
            <div
              v-if="observacaoLoading || hasObservacao"
              class="observacao-row"
            >
              <div
                v-if="observacaoLoading"
                class="observacao-loading"
              >
                <v-progress-linear
                  indeterminate
                  height="3"
                  color="primary"
                />
              </div>
              <div
                v-else
                class="observacao-text"
              >
                <span class="material-icons observacao-icon">notes</span>
                {{ observacao }}
              </div>
            </div>
          </v-expand-transition>
        </div>

        <!-- Ações -->
        <div class="compact-actions">
          <slot name="actions" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import medicoService from '@/services/medico.service'

export default {
  name: 'PacienteCardCompact',
  
  props: {
    paciente: {
      type: Object,
      required: true
    },
    flat: {
      type: Boolean,
      default: false
    },
    isEspera: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    listIndex: {
      type: Number,
      default: null
    }
  },
  emits: ['selecionar-paciente', 'click'],

  data() {
    return {
      exames: [], // Exames retornados da OS
      observacao: '',
      dataAgendadaTexto: '',
      observacaoLoading: false,
      observacaoLoaded: false,
      currentTime: Date.now(),
      tempoEsperaInterval: null
    }
  },

  computed: {
    user() {
      return this.$store.getters.usuario
    },
    prioridadeValor() {
      const direto = this.paciente?.prioridade
      if (direto !== null && direto !== undefined && direto !== '') {
        const num = Number(direto)
        return Number.isNaN(num) ? null : num
      }
      const atendimentos = this.paciente?.atendimentos || []
      for (const atendimento of atendimentos) {
        const valor = atendimento?.prioridade
        if (valor !== null && valor !== undefined && valor !== '') {
          const num = Number(valor)
          return Number.isNaN(num) ? null : num
        }
      }
      return null
    },
    hasPriority() {
      return this.prioridadeValor === 1 || this.prioridadeValor === 3
    },
    
    avatarGradient() {
      if (this.hasPriority) return 'gradient-priority'
      if (this.isEspera) return 'gradient-waiting'
      return 'gradient-normal'
    },
    
    tempoEsperaAtual() {
      const inicio = this.getChegadaTimestamp()
      if (!inicio) return ''
      const fim = this.getReferenciaFimEspera()
      if (!fim) return ''
      const diferenca = Math.max(0, fim - inicio)
      return this.formatarDuracao(diferenca)
    },
    tempoEsperaMinutos() {
      const inicio = this.getChegadaTimestamp()
      if (!inicio) return 0
      const fim = this.getReferenciaFimEspera()
      if (!fim) return 0
      const diferenca = Math.max(0, fim - inicio)
      return Math.floor(diferenca / 60000)
    },
    horarioChegada() {
      const timestamp = this.getChegadaTimestamp()
      if (!timestamp) return ''
      const data = new Date(timestamp)
      return data.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    tempoAtendimentoAtual() {
      if (!this.isAtendido) return ''
      const inicio = this.getChegadaTimestamp()
      const fim = this.getSaidaTimestamp()
      if (!inicio || !fim) return ''
      const diferenca = Math.max(0, fim - inicio)
      return this.formatarDuracao(diferenca)
    },
    horarioSaida() {
      if (!this.isAtendido) return ''
      const timestamp = this.getSaidaTimestamp()
      if (!timestamp) return ''
      const data = new Date(timestamp)
      return data.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    dataAgendadaLabel() {
      return this.dataAgendadaTexto
        ? `Agendado: ${this.dataAgendadaTexto}`
        : 'Sem agendamento'
    },
    mostrarAgendamento() {
      return this.observacaoLoaded
    },
    idadeAtual() {
      if (!this.paciente?.dataNascimento) return ''
      return this.calcularIdade(this.paciente.dataNascimento).idade
    },
    hasObservacao() {
      return !!this.observacao
    },
    isAtendido() {
      return this.paciente?.status === 4
    },
    examChipStatusClass() {
      const status = this.paciente?.status
      if (status === 1) return 'exam-chip--available'
      if (status === 2) return 'exam-chip--pending'
      if (status === 3) return 'exam-chip--waiting'
      if (status === 4) return 'exam-chip--attended'
      return 'exam-chip--default'
    },
    convenioTexto() {
      const convenio = this.paciente?.convenio
      if (convenio === null || convenio === undefined) {
        return this.extrairConvenioDosExames()
      }
      if (typeof convenio === 'string') {
        const direto = convenio.trim()
        return direto || this.extrairConvenioDosExames()
      }
      if (typeof convenio === 'object') {
        const nome = convenio?.nome || convenio?.descricao || ''
        const direto = typeof nome === 'string' ? nome.trim() : ''
        return direto || this.extrairConvenioDosExames()
      }
      const direto = String(convenio).trim()
      return direto || this.extrairConvenioDosExames()
    }
  },

  watch: {
    isSelected(newValue) {
      if (newValue) {
        this.carregarObservacao()
      }
    },
    paciente: {
      handler(novoPaciente, antigoPaciente) {
        if (novoPaciente?.idOrdemServico !== antigoPaciente?.idOrdemServico) {
          this.observacao = ''
          this.observacaoLoaded = false
//          this.carregarObservacao()
        }
      }
    }
  },

  async mounted() {
    if (this.paciente?.idOrdemServico) {
      await this.carregarExames()
    }
    this.carregarObservacao()
    this.tempoEsperaInterval = setInterval(() => {
      this.currentTime = Date.now()
    }, 1000)
  },

  beforeUnmount() {
    if (this.tempoEsperaInterval) {
      clearInterval(this.tempoEsperaInterval)
      this.tempoEsperaInterval = null
    }
  },

  methods: {
    async carregarExames() {
      try {
        const idUsuario = this.user?.id
        if (!idUsuario) {
          console.warn('Usuário não encontrado para carregar exames da OS.')
          return
        }
        const response = await medicoService.medico.retornarExamesOsIdUsuario(this.paciente.idOrdemServico, idUsuario)

        // Ajuste dependendo de como sua API retorna os dados
        this.exames = (response?.data || []).map(exame => {
          if (exame && typeof exame === 'object') {
            const nome = exame.nome || exame.descricao || ''
            const statusLabel = this.extrairStatusExame(exame, nome)
            const nomeNormalizado = this.normalizarNomeExame(nome)
            return {
              ...exame,
              nome: nomeNormalizado,
              statusLabel,
              label: nomeNormalizado
            }
          }
          return exame
        })

      } catch (error) {
        console.error("Erro ao carregar exames da OS:", error)
      }
    },

    pacienteSelecionado(event) {
      if (this.paciente?.status === 2 && event?.detail > 1) {
        return
      }
      this.$emit('click', this.paciente);
    },

    calcularIdade(dataNascimento) {
      if (!dataNascimento) return { idade: 0 }
      
      const hoje = new Date()
      const nascimento = new Date(dataNascimento)
      let idade = hoje.getFullYear() - nascimento.getFullYear()
      const m = hoje.getMonth() - nascimento.getMonth()
      
      if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
        idade--
      }

      return { idade }
    },

    truncateText(text, maxLength) {
      if (!text) return ''
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
    },

    normalizarNomeExame(texto) {
      if (!texto) return ''
      const semTags = texto.replace(/<[^>]*>/g, '')
      return semTags.replace(/\s*\(ATENDIDO\)\s*$/i, '').trim()
    },

    extrairTipoConvenio(exame) {
      if (!exame || typeof exame !== 'object') return ''
      const direto = exame.convenioTipo || exame.tipoConvenio || exame.tipo_convenio || exame.convenio_tipo
      if (typeof direto === 'string') return direto.trim()
      if (direto !== null && direto !== undefined) return String(direto).trim()
      const convenio = exame.convenio
      if (typeof convenio === 'string') return convenio.trim()
      if (convenio && typeof convenio === 'object') {
        const tipo = convenio.tipo || convenio.descricao || convenio.nome
        return typeof tipo === 'string' ? tipo.trim() : ''
      }
      return ''
    },
    extrairStatusExame(exame) {
      if (!exame || typeof exame !== 'object') return ''
      const normalizar = (valor) => {
        if (valor === null || valor === undefined) return ''
        const texto = typeof valor === 'string' ? valor : String(valor)
        return texto
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toUpperCase()
          .trim()
      }

      const statusExecuta = normalizar(exame.statusexecuta || exame.statusExecuta)
      if (statusExecuta) {
        if (statusExecuta === 'D') return 'Revisão'
        if (statusExecuta === 'A') return 'Atendido'
      }

      const statusExame = normalizar(exame.status_exame)
      if (statusExame === 'D') return 'Revisão'
      if (statusExame === 'A') return 'Atendido'
      return ''
    },
    extrairConvenioDosExames() {
      if (!Array.isArray(this.exames) || this.exames.length === 0) return ''
      for (const exame of this.exames) {
        const convenioTipo = this.extrairTipoConvenio(exame)
        if (convenioTipo) return convenioTipo
      }
      return ''
    },

    getChegadaTimestamp() {
      if (!this.paciente?.dataChegada) return null
      return this.parseDataChegada(this.paciente.dataChegada)
    },
    getSaidaTimestamp() {
      if (!this.paciente?.dataFinalAtendimento) return null
      return this.parseDataChegada(this.paciente.dataFinalAtendimento)
    },
    getReferenciaFimEspera() {
      if (this.isAtendido) {
        return this.getSaidaTimestamp()
      }
      return this.currentTime
    },

    parseDataChegada(valor) {
      if (!valor) return null
      if (valor instanceof Date) {
        const parsed = valor.getTime()
        return Number.isNaN(parsed) ? null : parsed
      }
      if (typeof valor === 'number') return valor

      const parsed = new Date(valor).getTime()
      if (!Number.isNaN(parsed)) return parsed

      if (typeof valor === 'string') {
        const match = valor.match(
          /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/
        )
        if (match) {
          const [, dd, mm, yyyy, hh = '00', min = '00', ss = '00'] = match
          const fallback = new Date(
            Number(yyyy),
            Number(mm) - 1,
            Number(dd),
            Number(hh),
            Number(min),
            Number(ss)
          ).getTime()
          return Number.isNaN(fallback) ? null : fallback
        }
      }

      return null
    },
    formatarDuracao(ms) {
      const minutos = Math.floor(ms / 60000)
      const horas = Math.floor(minutos / 60)
      const minsRestantes = minutos % 60
      if (horas > 0) {
        return `${horas}h ${minsRestantes.toString().padStart(2, '0')}min`
      }
      return `${minsRestantes} min`
    },

    async carregarObservacao() {
      if (this.observacaoLoading || this.observacaoLoaded) return
      if (!this.paciente?.idOrdemServico) return

      this.observacaoLoading = true
      try {
        const response = await medicoService.medico.retornarObservacaoOrdemServico(
          this.paciente.idOrdemServico
        )
        console.log('carregarObservacao: ', response?.data);
        
        const { observacao, dataAgendadaTexto } = this.normalizarObservacao(response?.data)
        this.observacao = observacao
        this.dataAgendadaTexto = dataAgendadaTexto
        this.observacaoLoaded = true
      } catch (error) {
        console.error('Erro ao carregar observacao da OS:', error)
      } finally {
        this.observacaoLoading = false
      }
    },

    normalizarObservacao(payload) {
      if (!payload) return { observacao: '', dataAgendadaTexto: '' }
      if (typeof payload === 'string') {
        const parsed = this.tentarParseJson(payload)
        if (parsed) {
          return this.extrairObservacaoData(parsed)
        }
        return { observacao: payload.trim(), dataAgendadaTexto: '' }
      }
      if (Array.isArray(payload)) {
        const item = payload.find(entry => entry?.observacao || entry?.dataAgendada) || payload[0]
        return this.extrairObservacaoData(item)
      }
      return this.extrairObservacaoData(payload)
    },

    extrairObservacaoData(item) {
      if (!item) return { observacao: '', dataAgendadaTexto: '' }
      const observacao = typeof item === 'string' ? item.trim() : (item?.observacao || '').trim()
      const dataAgendadaTexto = this.formatarDataAgendada(item?.dataAgendada || item?.data_agendada)
      return { observacao, dataAgendadaTexto }
    },

    formatarDataAgendada(valor) {
      const data = this.parseDataAgendada(valor)
      if (!data) return ''
      return data.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    parseDataAgendada(valor) {
      if (!valor) return null
      if (valor instanceof Date) {
        return Number.isNaN(valor.getTime()) ? null : valor
      }
      if (typeof valor === 'number') {
        const data = new Date(valor)
        return Number.isNaN(data.getTime()) ? null : data
      }
      if (typeof valor === 'string') {
        const texto = valor.trim()
        if (/^\d{4}-\d{2}-\d{2}/.test(texto)) {
          const data = new Date(texto)
          return Number.isNaN(data.getTime()) ? null : data
        }
        const match = texto.match(
          /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/
        )
        if (match) {
          const [, dd, mm, yyyy, hh = '00', min = '00', ss = '00'] = match
          const data = new Date(
            Number(yyyy),
            Number(mm) - 1,
            Number(dd),
            Number(hh),
            Number(min),
            Number(ss)
          )
          return Number.isNaN(data.getTime()) ? null : data
        }
      }
      return null
    },

    tentarParseJson(texto) {
      const trimmed = texto.trim()
      if (!trimmed.startsWith('{') || !trimmed.endsWith('}')) return null
      try {
        return JSON.parse(trimmed)
      } catch {
        return null
      }
    }
  }
}
</script>

<style scoped>
.paciente-card-compact {
  border-radius: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: rgb(var(--v-theme-surface));
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  margin-bottom: 6px;
  min-height: 70px;
  height: auto;
}

.paciente-card-compact:hover {
  border-color: rgb(var(--v-theme-primary));
  box-shadow: 0 2px 6px rgba(var(--v-theme-on-surface), 0.1);
  transform: translateY(-1px);
}

.paciente-card-compact.paciente-card-selected {
  border: 2px solid rgb(var(--v-theme-primary));
  box-shadow: 0 4px 15px rgba(var(--v-theme-primary), 0.3);
  transform: scale(1.02);
}

.paciente-card-compact.priority-patient {
  border-left: 3px solid #4dabf7;
}

.paciente-card-compact.waiting-patient {
  border-left: 3px solid rgb(var(--v-theme-warning));
}

.compact-card-content {
  display: flex;
  align-items: stretch;
  gap: 10px;
  height: 100%;
}

/* Avatar compacto */
.compact-avatar {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
  margin-top: 2px;
}

.status-available-card .compact-avatar,
.status-available-card .compact-avatar.gradient-normal {
  background: rgb(var(--v-theme-success));
}

.status-available-card .avatar-number {
  color: rgb(var(--v-theme-on-success));
}

.status-pending-card .compact-avatar,
.status-pending-card .compact-avatar.gradient-normal {
  background: rgb(var(--v-theme-success));
}

.priority-patient .compact-avatar {
  background: linear-gradient(135deg, #4dabf7 0%, #74c0fc 100%);
}

.priority-patient .avatar-number {
  color: #ffffff;
}

.status-pending-card .avatar-number {
  color: rgb(var(--v-theme-on-success));
}

.gradient-normal {
  background: linear-gradient(135deg, rgb(var(--v-theme-primary)) 0%, rgb(var(--v-theme-primary)) 100%);
}

.gradient-priority {
  background: linear-gradient(135deg, #4dabf7 0%, #74c0fc 100%);
}

.gradient-waiting {
  background: linear-gradient(135deg, rgb(var(--v-theme-warning)) 0%, rgb(var(--v-theme-warning)) 100%);
}

.avatar-number {
  color: rgb(var(--v-theme-on-primary));
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  transition: opacity 0.3s ease;
}


.selection-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: rgb(var(--v-theme-primary));
  border-radius: 10px;
  padding: 2px;
  border: 1px solid rgb(var(--v-theme-surface));
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.selection-icon {
  color: white;
  font-size: 14px;
}

.priority-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  color: #4dabf7;
  background: rgba(77, 171, 247, 0.18);
  border-radius: 999px;
  width: 18px;
  height: 18px;
}

.priority-icon .material-icons {
  font-size: 14px;
  line-height: 1;
}

.waiting-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 6px;
  height: 6px;
  background: rgb(var(--v-theme-error));
  border-radius: 50%;
  border: 1px solid rgb(var(--v-theme-surface));
}

/* Informações compactas */
.compact-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.compact-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.name-line {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex-wrap: wrap;
}

.compact-header h4.selected-header-text {
  color: rgb(var(--v-theme-primary));
  font-weight: 700;
}

.compact-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin: 0;
  line-height: 1.2;
  min-width: 0;
}

.patient-age {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  color: rgba(var(--v-theme-on-surface), 0.75);
  background: rgba(var(--v-theme-on-surface), 0.05);
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;
}

.patient-age-label {
  color: rgba(var(--v-theme-on-surface), 0.6);
  font-weight: 600;
}

.compact-badges {
  display: flex;
  gap: 3px;
}

.priority-mini,
.waiting-mini {
  min-width: 22px !important;
  height: 18px !important;
  color: rgb(var(--v-theme-on-error)) !important; /* Ou on-warning para waiting-mini */
}

.priority-mini .material-icons,
.waiting-mini .material-icons {
  font-size: 12px !important;
}

.paciente-card-compact :deep(.v-chip) {
  border-radius: 0 !important;
}

.patient-info-list {
  list-style: none;
  padding: 0;
  margin: 2px 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, max-content));
  gap: 4px 8px;
}

.patient-info-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  color: rgba(var(--v-theme-on-surface), 0.75);
  background: rgba(var(--v-theme-on-surface), 0.05);
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  padding: 2px 6px;
  border-radius: 4px;
}

.patient-info-item--arrival {
  color: rgb(var(--v-theme-primary));
  font-weight: 700;
}

.patient-info-item--arrival .patient-info-icon {
  color: rgb(var(--v-theme-primary));
}

.patient-info-item--wait-warning {
  background: rgba(var(--v-theme-warning), 0.12);
  border-color: rgba(var(--v-theme-warning), 0.4);
  color: rgb(var(--v-theme-warning));
}

.patient-info-item--wait-warning .patient-info-icon {
  color: rgb(var(--v-theme-warning));
}

.patient-info-item--wait-danger {
  background: rgba(var(--v-theme-error), 0.12);
  border-color: rgba(var(--v-theme-error), 0.4);
  color: rgb(var(--v-theme-error));
}

.patient-info-item--wait-danger .patient-info-icon {
  color: rgb(var(--v-theme-error));
}

.patient-info-icon {
  font-size: 12px;
  line-height: 1;
  color: rgba(var(--v-theme-on-surface), 0.7);
}

/* Exames em linha compactos */
.exams-line {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  margin-top: 4px;
}

.exam-chip {
  max-width: 220px;
}

.exam-icon {
  color: rgba(var(--v-theme-on-surface), 0.7);
  flex-shrink: 0;
}

.exam-text {
  font-size: 0.75rem;
  color: rgb(var(--v-theme-on-surface));
  line-height: 1.2;
  white-space: normal;
}

.exam-status {
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  background: rgba(var(--v-theme-on-surface), 0.08);
  color: rgba(var(--v-theme-on-surface), 0.75);
  border: 1px solid rgba(var(--v-theme-on-surface), 0.2);
  line-height: 1;
  white-space: nowrap;
}

.exam-chip--large {
  height: 30px;
  padding: 0 10px;
}

.exam-chip--available {
  background: rgba(76, 175, 80, 0.12);
  border-color: rgba(76, 175, 80, 0.35);
  color: rgb(46, 125, 50);
}

.exam-chip--pending {
  background: rgba(33, 150, 243, 0.12);
  border-color: rgba(33, 150, 243, 0.35);
  color: rgb(21, 101, 192);
}

.exam-chip--waiting {
  background: rgba(255, 193, 7, 0.14);
  border-color: rgba(255, 193, 7, 0.35);
  color: rgb(245, 124, 0);
}

.exam-chip--attended {
  background: rgba(156, 39, 176, 0.12);
  border-color: rgba(156, 39, 176, 0.35);
  color: rgb(123, 31, 162);
}

.exam-chip--default {
  background: rgba(var(--v-theme-on-surface), 0.05);
  border-color: rgba(var(--v-theme-on-surface), 0.12);
  color: rgb(var(--v-theme-on-surface));
}

.exam-chip--convenio {
  background: rgba(0, 150, 136, 0.12);
  border-color: rgba(0, 150, 136, 0.35);
  color: rgb(0, 105, 92);
}

.more-exams {
  font-size: 0.65rem;
  color: rgba(var(--v-theme-on-surface), 0.7);
  background: rgb(var(--v-theme-background));
  padding: 2px 5px;
  border-radius: 4px;
  font-weight: 600;
}

.observacao-row {
  margin-top: 6px;
  padding: 6px 8px;
  border-radius: 8px;
  background: rgba(var(--v-theme-on-surface), 0.04);
  border: 1px dashed rgba(var(--v-theme-on-surface), 0.12);
}

.observacao-text {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 0.75rem;
  color: rgb(var(--v-theme-on-surface));
  line-height: 1.3;
}

.observacao-icon {
  font-size: 14px;
  color: rgba(var(--v-theme-on-surface), 0.7);
  margin-top: 2px;
}

.observacao-loading {
  padding: 4px 0;
}

/* Demográficos compactos */
.compact-actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  margin-left: auto;
  flex-shrink: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .compact-card-content {
    gap: 8px;
  }
  
  .compact-avatar {
    width: 32px;
    height: 32px;
  }
  
  .avatar-number {
    font-size: 12px;
  }
  
  .compact-name {
    font-size: 0.8rem;
  }
  
  .exam-text {
    font-size: 0.65rem;
  }
  
  .exams-line {
    gap: 3px;
  }
  
  .exam-chip {
    max-width: 100px;
  }
}
</style>
